export default __webpack_public_path__ + "static/media/1.827de07a.webp";